import React, { FC, useState, useEffect } from 'react';

import {
  HeaderRow,
  StyledTab,
  TabsAnimationWrapper,
  TabsContainer,
} from '~src/modules/reports/reportsHeader/containers/ReportsHeader.sc';
import { Tab } from '~src/modules/reports/interfaces/header.interface';
import { useTranslation } from 'react-i18next';
interface Props {
  noTabs: boolean;
  tabs: Tab[];
  selectedTabIndex: number;
  status: string;
  tabSelect: (tab: Tab) => void;
}

const Tabs: FC<Props> = React.memo(function Tabs(props) {
  const [selectedTab, setSelectedTab] = useState(props.selectedTabIndex);
  const [t] = useTranslation();
  useEffect(() => {
    setSelectedTab(props.selectedTabIndex);
  }, [props.selectedTabIndex]);

  const tabSelect = (tab: Tab, index: number) => {
    setSelectedTab(index);
    props.tabSelect(tab);
  };

  return (
    <TabsAnimationWrapper>
      <TabsContainer className={props.status} $noTabs={props.noTabs}>
        <HeaderRow gutter={30}>
          {props.tabs.map((tab, index) => (
            <StyledTab key={tab.link} $selected={index === selectedTab} onClick={() => tabSelect(tab, index)}>
              <span data-translation={tab.translationKey}>{t(tab.translationKey, tab.translationParams)}</span>
            </StyledTab>
          ))}
        </HeaderRow>
      </TabsContainer>
    </TabsAnimationWrapper>
  );
});

export default Tabs;
